module.exports = __webpack_public_path__ + "media/images/clientes-cuenta-general-0219825f64ebcd85d61fb6960a066c16.png";